import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7823339e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "m-flex-box"
}
const _hoisted_2 = { class: "m-progress" }
const _hoisted_3 = {
  key: 1,
  class: "m-active-progress u-width0"
}
const _hoisted_4 = { class: "m-percent-num" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["m-progress-wrap", {'u-margin-44': $props.progressData?.isFinished}])
    }, [
      _createElementVNode("div", null, _toDisplayString($props.progressData?.progressText), 1)
    ], 2),
    ($props.progressData?.isFinished === false)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            ($props.progressData?.currentLevelFinishTaskNum)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(($props.progressData.currentLevelFinishTaskNum - 1), (i) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: `separator-${i}`,
                    class: "u-separator",
                    style: _normalizeStyle({left: `${ i * 100 / $props.progressData.currentLevelFinishTaskNum}%`})
                  }, null, 4))
                }), 128))
              : _createCommentVNode("", true),
            ($props.progressData?.progressWidth === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3))
              : (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: "m-active-progress",
                  style: _normalizeStyle({width: `${$props.progressData?.progressWidth}%`})
                }, null, 4))
          ]),
          _createElementVNode("div", _hoisted_4, _toDisplayString($props.progressData?.currentLevelFinishedTaskNum > $props.progressData?.currentLevelFinishTaskNum ? $props.progressData?.currentLevelFinishTaskNum : $props.progressData?.currentLevelFinishedTaskNum) + "/" + _toDisplayString($props.progressData?.currentLevelFinishTaskNum), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}